import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Modal,
  Heading,
  ModalFooter,
  ButtonGroup,
} from '@studio/legacy-components';

export default function ConfirmDiscardChangesModal({
  onPublish,
  onClose,
  visible,
}) {
  return (
    <Modal visible={visible} onClose={onClose} size="m">
      <Heading>Are you sure you want to publish?</Heading>
      <ModalFooter>
        <ButtonGroup>
          <Button kind="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onPublish}>Confirm</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
}

ConfirmDiscardChangesModal.propTypes = {
  onPublish: PropTypes.func,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};
